import { ScreenSize } from '@/graphql/typeNames';

const screenSize = (__, { tablet, desktop }, { cache }) => {
    const screenSize = {
        __typename: ScreenSize,
        tablet,
        desktop,
    };

    cache.writeData({
        data: { screenSize },
    });

    return screenSize;
};

export default screenSize;
